import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import {
  ORDER_TABLE_FIELDS as OK,
  ORDER_STATUS,
  ORDER_STATUS_CLASSES,
} from 'utils/constants'
import {
  conditionalDateFormatter,
  convertTo12HourFormat,
} from 'utils/helpers/date'

const valueFormatter = (params: ValueFormatterParams) => params.value || '-'

export const getStatus = (value?: boolean) => {
  return value === true ? 'Success' : value === false ? 'Fail' : '-'
}

export const OPEN_ORDER_STATUSES = [
  ORDER_STATUS.ON_HOLD,
  ORDER_STATUS.PICKING_IN_PROGRESS,
  ORDER_STATUS.PENDING_FOR_PICKUP,
]

export const openOrderColumns = [
  { headerName: OK.ORDER_NO.label, field: OK.ORDER_NO.value, minWidth: 150 },
  {
    headerName: OK.INVOICE_NO.label,
    field: OK.INVOICE_NO.value,
    minWidth: 200,
  },
  {
    headerName: OK.ORDER_SHORTCODE.label,
    field: OK.ORDER_SHORTCODE.value,
    minWidth: 150,
  },
  {
    headerName: OK.AGGREGATOR_CODE.label,
    field: OK.AGGREGATOR_CODE.value,
    minWidth: 130,
  },
  {
    headerName: OK.STORE_CODE.label,
    field: OK.STORE_CODE.value,
    minWidth: 130,
  },
  {
    headerName: OK.STORE_NAME.label,
    field: OK.STORE_NAME.value,
    minWidth: 150,
  },
  {
    headerName: OK.ORDER_PLACE_DATETIME.label,
    field: OK.ORDER_PLACE_DATETIME.value,
    minWidth: 170,
    valueFormatter: conditionalDateFormatter,
  },
  {
    headerName: OK.ORDER_POSTING_DATE.label,
    field: OK.ORDER_POSTING_DATE.value,
    minWidth: 170,
    valueFormatter: (params: ValueFormatterParams) =>
      convertTo12HourFormat(params.value),
  },
  {
    headerName: OK.PLANNED_DELIVERY_DATE.label,
    field: OK.PLANNED_DELIVERY_DATE.value,
    minWidth: 170,
    valueFormatter: conditionalDateFormatter,
  },
  {
    headerName: OK.PREPARED_BY.label,
    field: OK.PREPARED_BY.value,
    valueFormatter,
  },
  {
    headerName: OK.EMP_ID.label,
    field: OK.EMP_ID.value,
    valueFormatter,
  },
  {
    headerName: OK.CUSTOMER_NAME.label,
    field: OK.CUSTOMER_NAME.value,
    minWidth: 120,
    valueFormatter,
  },
  { headerName: OK.AREA.label, field: OK.AREA.value, valueFormatter },
  {
    headerName: OK.CONTACT.label,
    field: OK.CONTACT.value,
    minWidth: 130,
    valueFormatter,
  },
  {
    headerName: OK.STATUS.label,
    field: OK.STATUS.value,
    minWidth: 200,
    cellRenderer: ({ value }: ICellRendererParams) => {
      return (
        <span
          className={`rounded-lg px-2 py-1 font-sans text-sm font-bold ${
            ORDER_STATUS_CLASSES[value!]
          }`}
        >
          {value}
        </span>
      )
    },
  },
] as ColDef[]

export const FILTER_FIELD_OPEN_ORDERS = 'openOrderFilters'
